export const LISTENING_OVERVIEW_SINGLE_TOPIC = [
  {
    h: 8,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 0,
    y: 0,
    meta: {
      aggregate_by: 'TOTAL',
      channels: ['INSTAGRAM'],
      listening: { comparison_topic_ids: ['comparison_ids'], topic_ids: ['topic_ids'] },
      metrics: ['TOTAL_MENTIONS_TOPIC'],
    },
  },
  {
    h: 8,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 1,
    y: 0,
    meta: {
      aggregate_by: 'TOTAL',
      channels: ['INSTAGRAM'],
      listening: { comparison_topic_ids: ['comparison_ids'], topic_ids: ['topic_ids'] },
      metrics: ['TOTAL_ENGAGEMENTS_TOPIC'],
    },
  },
  {
    h: 8,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 2,
    y: 0,
    meta: {
      aggregate_by: 'TOTAL',
      channels: ['INSTAGRAM'],
      listening: { comparison_topic_ids: ['comparison_ids'], topic_ids: ['topic_ids'] },
      metrics: ['TOTAL_IMPRESSIONS_TOPIC'],
    },
  },
  {
    h: 8,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 3,
    y: 0,
    meta: {
      aggregate_by: 'TOTAL',
      channels: ['INSTAGRAM'],
      listening: { comparison_topic_ids: ['comparison_ids'], topic_ids: ['topic_ids'] },
      metrics: ['NET_SENTIMENT'],
    },
  },
  {
    h: 8,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 0,
    y: 8,
    meta: {
      aggregate_by: 'TOTAL',
      channels: ['INSTAGRAM'],
      listening: { comparison_topic_ids: ['comparison_ids'], topic_ids: ['topic_ids'] },
      metrics: ['AVG_MENTIONS_TOPIC'],
    },
  },
  {
    h: 8,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 1,
    y: 8,
    meta: {
      aggregate_by: 'TOTAL',
      channels: ['INSTAGRAM'],
      listening: { comparison_topic_ids: ['comparison_ids'], topic_ids: ['topic_ids'] },
      metrics: ['AVERAGE_ENGAGEMENTS_PER_POST'],
    },
  },
  {
    h: 8,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 2,
    y: 8,
    meta: {
      aggregate_by: 'TOTAL',
      channels: ['INSTAGRAM'],
      listening: { comparison_topic_ids: ['comparison_ids'], topic_ids: ['topic_ids'] },
      metrics: ['AVERAGE_IMPRESSIONS_PER_POST'],
    },
  },
  {
    h: 16,
    type: 'BAR_METRIC',
    w: 6,
    x: 0,
    y: 16,
    meta: {
      aggregate_by: 'CHANNEL',
      channels: ['INSTAGRAM'],
      listening: { comparison_topic_ids: ['comparison_ids'], topic_ids: ['topic_ids'] },
      metrics: ['TOTAL_MENTIONS_TOPIC'],
    },
  },
  {
    h: 16,
    type: 'BAR_METRIC',
    w: 3,
    x: 0,
    y: 32,
    meta: {
      aggregate_by: 'MEDIA_TYPE',
      channels: ['INSTAGRAM'],
      listening: { comparison_topic_ids: ['comparison_ids'], topic_ids: ['topic_ids'] },
      metrics: ['TOTAL_MENTIONS_TOPIC'],
    },
  },
  {
    h: 16,
    type: 'BAR_METRIC',
    w: 3,
    x: 3,
    y: 32,
    meta: {
      aggregate_by: 'SENTIMENT',
      channels: ['INSTAGRAM'],
      listening: { comparison_topic_ids: ['comparison_ids'], topic_ids: ['topic_ids'] },
      metrics: ['TOTAL_MENTIONS_TOPIC'],
    },
  },
  {
    h: 16,
    type: 'GRAPH',
    w: 3,
    x: 0,
    y: 48,
    meta: {
      channels: ['INSTAGRAM'],
      listening: { comparison_topic_ids: ['comparison_ids'], topic_ids: ['topic_ids'] },
      metrics: ['TOTAL_MENTIONS_TOPIC'],
    },
  },
  {
    h: 16,
    type: 'GRAPH',
    w: 3,
    x: 3,
    y: 48,
    meta: {
      channels: ['INSTAGRAM'],
      listening: { comparison_topic_ids: ['comparison_ids'], topic_ids: ['topic_ids'] },
      metrics: ['TOTAL_IMPRESSIONS_TOPIC'],
    },
  },
  {
    h: 16,
    type: 'GRAPH',
    w: 3,
    x: 0,
    y: 64,
    meta: {
      channels: ['INSTAGRAM'],
      listening: { comparison_topic_ids: ['comparison_ids'], topic_ids: ['topic_ids'] },
      metrics: ['TOTAL_ENGAGEMENTS_TOPIC'],
    },
  },
  {
    h: 16,
    type: 'GRAPH',
    w: 3,
    x: 3,
    y: 64,
    meta: {
      channels: ['INSTAGRAM'],
      listening: { comparison_topic_ids: ['comparison_ids'], topic_ids: ['topic_ids'] },
      metrics: ['NET_SENTIMENT'],
    },
  },
  {
    h: 16,
    type: 'HORIZONTAL_BAR_METRIC',
    w: 3,
    x: 0,
    y: 80,
    meta: {
      aggregate_by: 'GENDER',
      channels: ['INSTAGRAM'],
      display_strategy: 'PERCENT_OF_GRAND_TOTAL',
      listening: { comparison_topic_ids: ['comparison_ids'], topic_ids: ['topic_ids'] },
      metrics: ['TOTAL_MENTIONS_TOPIC'],
    },
  },
  {
    h: 16,
    type: 'HORIZONTAL_BAR_METRIC',
    w: 3,
    x: 3,
    y: 80,
    meta: {
      aggregate_by: 'AGE',
      channels: ['INSTAGRAM'],
      display_strategy: 'PERCENT_OF_GRAND_TOTAL',
      listening: { comparison_topic_ids: ['comparison_ids'], topic_ids: ['topic_ids'] },
      metrics: ['TOTAL_MENTIONS_TOPIC'],
    },
  },
  {
    h: 16,
    type: 'HORIZONTAL_BAR_METRIC',
    w: 3,
    x: 0,
    y: 96,
    meta: {
      aggregate_by: 'COUNTRY',
      channels: ['INSTAGRAM'],
      listening: { comparison_topic_ids: ['comparison_ids'], topic_ids: ['topic_ids'] },
      metrics: ['TOTAL_MENTIONS_TOPIC'],
    },
  },
  {
    h: 16,
    type: 'HORIZONTAL_BAR_METRIC',
    w: 3,
    x: 3,
    y: 96,
    meta: {
      aggregate_by: 'CITY',
      channels: ['INSTAGRAM'],
      listening: { comparison_topic_ids: ['comparison_ids'], topic_ids: ['topic_ids'] },
      metrics: ['TOTAL_MENTIONS_TOPIC'],
    },
  },
  {
    h: 20,
    type: 'CONTENT',
    w: 6,
    x: 0,
    y: 128,
    meta: {
      channels: ['INSTAGRAM'],
      listening: { comparison_topic_ids: ['comparison_ids'], topic_ids: ['topic_ids'] },
      metrics: ['ENGAGEMENTS'],
      sort_order: 'DESC',
    },
  },
];
